import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileName"];

  handleChange({ target }) {
    const filename = target.value.split("\\").pop();
    this.fileNameTarget.innerHTML = filename;
  }
}
